<form [class.label-fixed]="isLabelFixed()">
  @if (showIcon() && iconSource()) {
    <app-svg-icon class="input-icon" [src]="iconSource()"></app-svg-icon>
  }
  <input
    [type]="type()"
    [name]="uniqueId()"
    [id]="uniqueId()"
    [attr.autocomplete]="autocomplete()"
    [title]="label()"
    [placeholder]="placeholder()"
    [formControl]="control()"
  >
  <label
    [class.caption]="!isLabelFixed()"
    [class.fixed-label]="isLabelFixed()"
    [id]="uniqueId() + '-label'"
    [for]="uniqueId()"
  >
    {{ label() }}
    @if (required()) {
      <span class="required-asterisk" aria-hidden="true"> *</span>
    }
  </label>
</form>
